import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IExternalEntityCriteria } from 'src/app/masters/peoples/external-entity/external-entity.interface';
import { DataService } from 'src/app/shared/services/data.service';
import { Api } from 'src/app/shared/constants/api';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import * as _ from 'underscore';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { Message } from 'src/app/shared/constants/message';
import { ReplaySubject, Subject } from 'rxjs';
import { IVessel } from '../vessel.interface';


@Component({
    selector: 'app-vessel-form',
    templateUrl: './vessel-form.component.html',
    styleUrls: ['./vessel-form.component.less'],
    standalone: false
})
export class VesselFormComponent implements OnInit {

  vOperators: any
  vesselForm: FormGroup;
  operatorCriteria:IExternalEntityCriteria={};
  showStatus:string;
  showDeactivateToggle=false;
  showReactivateToggle=false;
  searching:boolean = false;
  checked:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  addPermission:boolean=false;
  editPermission:boolean=false;
  dateUsedInTheCode :any;
  isEditedData:boolean;
  vesselSearchCtrl=this.formBuilder.control('');
  onDestroy = new Subject<void>();
  filteredVesselOperator:ReplaySubject<IVessel[]> = new ReplaySubject<IVessel[]>(1);
  // disable:any;
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dailogRef : MatDialogRef<VesselFormComponent>,
    private service:DataService,
    private utilityService: UtilityService,
    private dailog:MatDialog,
    private permissionService:PermissionService
  ) {
    dailogRef.disableClose=true;
  }

  ngOnInit(){
    this.checkAllPermission();
    this.initializeVesselForm();
    this.getOperators();
    this.filterVesselOperator();
    this.patchValue();
  }

  private patchValue() {
    if (this.data?.id) {
      this.showStatus = this.getStatus(this.data);
      this.vesselForm.patchValue(this.data);
      if(this.data.status == 'DEACTIVATED' || !this.editPermission){
        this.vesselForm.disable();
      }
    }
  }

  private initializeVesselForm(){
		this.vesselForm = this.formBuilder.group({
      id:[],
      name:[null,[Validators.required]],
      operatorId:[null],
      status:[],
      active:[],
      parentId:[]
		});
 	}

   private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval && this.deactivatePermission) {
      this.showDeactivateToggle=true;
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval && this.reactivatePermission) {
      this.showReactivateToggle=true;
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivationDetails?.deactivationWefDate,
        reactivationWefDate: data.reactivationDetails?.reactivationWefDate});
    }
  }
    /**
     * onSave
     */

    public onSave(){
      if(this.vesselForm.dirty && this.vesselForm.valid){
        this.isEditedData=true;
        this.id ? this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT):
        this.openDailog(Message.SAVE_OPEN_DAILOG);
      }
    }

    public save() {  
      this.vesselForm.markAllAsTouched();
      let method = (this.id) ? 'put' : 'post';
      let message=(this.id)?'updated':'saved';
      if(this.vesselForm.valid){
          this.service[method](Api.VESSEL, this.vesselForm.value).subscribe(res => {
            this.utilityService.notifier('Vessel Details '+message+' successfully', 'success');
            this.dailogRef.close();
        });
      }
    }

    /**
     * cancle
    */
    public cancel() {
      if(this.vesselForm.dirty){
        this.isEditedData=false;
        this.id?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):
            this.openDailog(Message.CANCEL_OPEN_DAILOG)
      }else{
          this.dailogRef.close();
      }  
    }

    openDailog(message:string){
     
      const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
          data:message,
          maxWidth:"300px",
          maxHeight:"150px"
        });
      
      dailogRef.afterClosed().subscribe(dailogResult => {
          if(dailogResult===false){
            return;
          }
          else {
            if(!this.isEditedData) {
              this.dailogRef.close();
            }else{
               this.save();
            }       
          }
          
      });
    }

    getOperators(){
      this.operatorCriteria.activeFlag=true;
      this.operatorCriteria.entityBusinessType='LINE';
      this.service.get(Api.EXTERNAL_ENTITY_FOR_DD, this.operatorCriteria).subscribe(res => {
         if(res){
           this.vOperators=res;
           this.filteredVesselOperator.next(this.vOperators);
         }
      })
    }

    filterVesselOperator(){
      this.vesselSearchCtrl.valueChanges.pipe(
        tap(() => this.searching = true),
        takeUntil(this.onDestroy),
        debounceTime(200),
        map(search => {
          if (!this.vOperators) { return []; }
          if(!search) { this.filteredVesselOperator.next(this.vOperators); }
          return this.vOperators.filter(vOperator => vOperator.name.toLowerCase().indexOf(search) > -1);
        }),
        delay(200)
      )
      .subscribe(filtered => {
        this.searching = false;
        this.filteredVesselOperator.next(filtered);
      },
      error => { this.searching = false; });
    }

    openDeactivateForm(e:MatSlideToggleChange)
    {
      let data={id:this.id,message:'Vessel',api:Api.DEACTIVATE_VESSEL,isReasonMandatory:false,route:APP_ROUTES.VESSEL_LIST}
      const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(value => {
        this.checked = !this.checked;
      })
    }
  
    openReactivateForm(e:MatSlideToggleChange)
    {
      let data={id:this.id,message:'Vessel',api:Api.REACTIVATE_VESSEL,isReasonMandatory:false,route:APP_ROUTES.VESSEL_LIST}
      const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
      dailogRef.afterClosed().subscribe(value => {
        this.checked = !this.checked;
      })
    }

    public checkAllPermission(){
      let permissionCodes=[PermissionKey.VESSEL_MODULE_REACTIVATE_PERMISSION,PermissionKey.VESSEL_MODULE_DEACTIVATE_PERMISSION,
        PermissionKey.VESSEL_MODULE_EDIT_PERMISSION,PermissionKey.VESSEL_MODULE_ADD_PERMISSION];
      let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.VESSEL_MODULE);
      this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
      this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
      this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_EDIT_PERMISSION})?.show?true:false;
      this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.VESSEL_MODULE_ADD_PERMISSION})?.show?true:false;
    }
   

    get name(){return this.vesselForm.get('name')};
    get operatorId(){return this.vesselForm.get('operatorId')};
    get id(){ return this.vesselForm.get('id').value };
    get status(){ return this.vesselForm.get('status') }
}
